import { createStitches as e } from "@stitches/react";
const _e = e(),
  r = _e.keyframes,
  o = _e.styled;
export { r as keyframes, o as styled };